import styled from "@emotion/styled";
import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import {
  ColDef,
  ICellRendererParams,
  SelectionChangedEvent,
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useFormik } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import { customTheme } from "../../../../../config/theme/MuiTheme";
import { ContextOperation } from "../../../context/OperationContext";
import { useAgGridCustomDatasource } from "../../../hooks/useAgGridCustomDatasource";
import GenericFilterBox from "../../common/GenericFilterBox";
import { nameof } from "../../common/ObjectUtils";
import OptionsColumn from "../../common/OptionsColumn";
import Dialogs from "./dialogs";
import { EquipmentKitDeleteTypes } from "./dialogs/DeleteConfirmation";
import {
  EquipmentKitRequests,
  EquipmentKitService,
} from "./EquipmentKitService";
import EquipmentKitTypes from "./Types";
import { useEquipmentKitTabTranslation } from "./Utils";
import { useHasScope } from "../../../../../config/globalConfig";
import AgGridOperationTable from "../../common/AgGridOperationTable";

// const StyledActionsBox = styled(Mui.Box)({
//   backgroundColor: customTheme.palette.neutral.bright,
//   width: "100%",
//   height: "100%",
//   display: "flex",
//   justifyContent: "center",
//   // margin: "100px",
// });

export const EquipmentKitTab = (props: any) => {
  const hasScope = useHasScope;
  const gridEquipmentKitsRef = useRef<AgGridReact>(null);
  const gridEquipmentsRef = useRef<AgGridReact>(null);
  const { tenant } = useContext(ContextOperation);
  const { t } = useEquipmentKitTabTranslation();

  const [equipmentKitId, setEquipmentKitId] = useState<undefined | number>(
    undefined
  );
  const [selectedEquipmentKit, setSelectedEquipmentKit] = useState<
    undefined | EquipmentKitTypes.IEquipmentKit
  >(undefined);
  const [selectedEquipment, setSelectedEquipment] = useState<
    undefined | EquipmentKitTypes.IEquipmentsValid
  >(undefined);

  const [equipmentKitDialog, setEquipmentKitDialog] = useState(false);
  const [addEquipmentVisible, setAddEquipmentVisible] = useState(false);
  const [deleteConfirmationVisible, setDeleteConfirmationVisible] =
    useState(false);
  const [deleteType, setDeleteType] = useState<EquipmentKitDeleteTypes>("kit");

  const onCloseEquipmentKitDialog = () => {
    setEquipmentKitId(undefined);
    setEquipmentKitDialog(false);
  };

  const onCloseAddEquipments = () => {
    setAddEquipmentVisible(false);
  };

  const onDeleteEquipmentKit = (
    equipmentKit: EquipmentKitTypes.IEquipmentKit
  ) => {
    setSelectedEquipmentKit(equipmentKit);
    setDeleteType("kit");
    setDeleteConfirmationVisible(true);
  };

  const onDetachEquipment = (equipment: EquipmentKitTypes.IEquipmentsValid) => {
    setSelectedEquipment(equipment);
    setDeleteType("equipment");
    setDeleteConfirmationVisible(true);
  };

  const formik = useFormik<EquipmentKitRequests.GetAll>({
    initialValues: {},
    onSubmit: () => {},
  });

  const [
    equipmentKitsDataSource,
    totalEquipmentKits,
    updateEquipmentKitsDatasource,
  ] = useAgGridCustomDatasource(
    EquipmentKitService.get.all,
    [tenant, formik.values],
    [tenant, formik.submitCount]
  );
  const [equipmentsDatasource, totalEquipments, updateEquipmentsDatasource] =
    useAgGridCustomDatasource(
      EquipmentKitService.get.equipmentsById,
      [tenant, selectedEquipmentKit?.id],
      [tenant, selectedEquipmentKit?.id]
    );

  const onUpdateDeleteConfirmation = () => {
    if (deleteType === "kit") {
      updateEquipmentKitsDatasource();
      setSelectedEquipmentKit(undefined);
    } else {
      updateEquipmentsDatasource();
    }
  };

  useEffect(() => {
    gridEquipmentKitsRef.current?.api.deselectAll();
  }, [formik.submitCount]);

  const equipmentKitColumns: ColDef[] = [
    {
      field: nameof<EquipmentKitTypes.IEquipmentKit>("code"),
      headerName: t("tables.equipmentKit.columns.code"),
      flex: 1,
    },
    {
      field: nameof<EquipmentKitTypes.IEquipmentKit>("descr"),
      headerName: t("tables.equipmentKit.columns.description"),
      flex: 1,
      cellRenderer: (
        props: ICellRendererParams<EquipmentKitTypes.IEquipmentKit>
      ) => {
        return (
          <Mui.Tooltip title={props?.value}>
            <Mui.Box
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              overflow="hidden"
            >
              {props?.value}
            </Mui.Box>
          </Mui.Tooltip>
        );
      },
    },
    {
      field: "",
      maxWidth: 100,
      // flex: 1,
      // cellStyle: {
      //   padding: "0px",
      //   border: "none",
      // },
      cellRenderer: (
        props: ICellRendererParams<EquipmentKitTypes.IEquipmentKit>
      ) => {
        return (
          <Mui.Stack
            direction="row"
            style={{ color: customTheme.palette.neutral.bright }}
          >
            {hasScope("SCOPE_UPDATE_MDVEHICLE_EQUIPMENT") && (
              <Mui.Tooltip title={t("tables.equipmentKit.tooltip.edit")}>
                <Mui.IconButton
                  color="accent"
                  onClick={() => {
                    setEquipmentKitDialog(true);
                    setEquipmentKitId(props.data?.id);
                  }}
                >
                  <MuiIcons.Edit />
                </Mui.IconButton>
              </Mui.Tooltip>
            )}

            {hasScope("SCOPE_DELETE_MDVEHICLE_EQUIPMENT") && (
              <Mui.Tooltip title={t("tables.equipmentKit.tooltip.delete")}>
                <Mui.IconButton
                  color="accent"
                  onClick={() =>
                    props.data?.id && onDeleteEquipmentKit(props.data)
                  }
                >
                  <MuiIcons.Delete />
                </Mui.IconButton>
              </Mui.Tooltip>
            )}
          </Mui.Stack>
          // <OptionsColumn>
          //   <Mui.Tooltip title={t("tables.equipmentKit.tooltip.edit")}>
          //     <Mui.IconButton
          //       color="accent"
          //       onClick={() => {
          //         setEquipmentKitDialog(true);
          //         setEquipmentKitId(props.data?.id);
          //       }}
          //     >
          //       <MuiIcons.Edit />
          //     </Mui.IconButton>
          //   </Mui.Tooltip>

          //   <Mui.Tooltip title={t("tables.equipmentKit.tooltip.delete")}>
          //     <Mui.IconButton
          //       color="accent"
          //       onClick={() =>
          //         props.data?.id && onDeleteEquipmentKit(props.data)
          //       }
          //     >
          //       <MuiIcons.Delete />
          //     </Mui.IconButton>
          //   </Mui.Tooltip>
          // </OptionsColumn>
        );
      },
    },
  ];

  const equipmentsColumns: ColDef[] = [
    {
      field: nameof<EquipmentKitTypes.IEquipmentsValid>("code"),
      headerName: t("tables.equipments.columns.code"),
      flex: 1,
    },
    {
      field: nameof<EquipmentKitTypes.IEquipmentsValid>("descr"),
      headerName: t("tables.equipments.columns.description"),
      flex: 1,
      cellRenderer: (
        props: ICellRendererParams<EquipmentKitTypes.IEquipmentsValid>
      ) => {
        return (
          <Mui.Tooltip title={props?.value}>
            <Mui.Box
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              overflow="hidden"
            >
              {props?.value}
            </Mui.Box>
          </Mui.Tooltip>
        );
      },
    },
    {
      maxWidth: 40,
      cellStyle: {
        padding: "0px",
        border: "none",
      },
      cellRenderer: (
        props: ICellRendererParams<EquipmentKitTypes.IEquipmentsValid>
      ) => {
        return (
          <Mui.Stack direction="row">
            {hasScope("SCOPE_UPDATE_MDVEHICLE_EQUIPMENT") && (
              <Mui.Tooltip title={t("tables.equipments.tooltip.delete")}>
                <Mui.IconButton
                  color="accent"
                  onClick={() => props.data && onDetachEquipment(props.data)}
                >
                  <MuiIcons.Delete />
                </Mui.IconButton>
              </Mui.Tooltip>
            )}
          </Mui.Stack>
        );
      },
    },
  ];

  const onSelectionChanged = (
    event: SelectionChangedEvent<EquipmentKitTypes.IEquipmentKit>
  ) => {
    const selectedRows = event.api.getSelectedRows();
    if (selectedRows && selectedRows.length > 0) {
      setSelectedEquipmentKit(selectedRows[0]);
    } else {
      setSelectedEquipmentKit(undefined);
    }
  };

  return (
    <>
      <Mui.Box>
        <form id="equipment-kit-tab-search-form" onSubmit={formik.handleSubmit}>
          <GenericFilterBox
            formId="equipment-kit-tab-search-form"
            onReset={() => formik.resetForm()}
          >
            <Mui.TextField
              name={nameof<EquipmentKitRequests.GetAll>("code")}
              label={t("fields.equipmentCode")}
              value={formik.values.code || ""}
              onChange={formik.handleChange}
              fullWidth={true}
            />

            <Mui.TextField
              name={nameof<EquipmentKitRequests.GetAll>("description")}
              label={t("fields.description")}
              value={formik.values.description || ""}
              onChange={formik.handleChange}
              fullWidth={true}
            />
          </GenericFilterBox>
        </form>

        <Mui.Grid container padding="16px" spacing="16px" height="100%">
          <Mui.Grid item md={8} xs={12}>
            <Mui.Card
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <Mui.CardHeader
                action={
                  <>
                    {hasScope("SCOPE_CREATE_MDVEHICLE_EQUIPMENT") && (
                      <Mui.Tooltip title={t("tooltip.addEquipmentKit")}>
                        <Mui.IconButton
                          color="accent"
                          onClick={() => setEquipmentKitDialog(true)}
                        >
                          <MuiIcons.Add />
                        </Mui.IconButton>
                      </Mui.Tooltip>
                    )}
                  </>
                }
                title={
                  <Mui.Typography variant="body">
                    {t("tables.equipmentKit.title")}
                  </Mui.Typography>
                }
              />

              <AgGridOperationTable
                gridRef={gridEquipmentKitsRef}
                columnDefs={equipmentKitColumns}
                serverSideDatasource={equipmentKitsDataSource}
                rowModelType="serverSide"
                serverSideInfiniteScroll={true}
                cacheBlockSize={10}
                rowSelection="single"
                onSelectionChanged={onSelectionChanged}
                totalElements={totalEquipmentKits}
                emptyState={{
                  title: t("tables.equipmentKit.emptyState.title"),
                  content: t("tables.equipmentKit.emptyState.content")
                }}
              />

            </Mui.Card>
          </Mui.Grid>

          <Mui.Grid item md={4} xs={12}>
            <Mui.Card
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <Mui.CardHeader
                action={
                  <>
                    {hasScope("SCOPE_UPDATE_MDVEHICLE_EQUIPMENT") && (
                      <Mui.Tooltip title={t("tooltip.editEquipments")}>
                        <Mui.IconButton
                          color="accent"
                          onClick={() => setAddEquipmentVisible(true)}
                          disabled={selectedEquipmentKit ? false : true}
                        >
                          <MuiIcons.Edit />
                        </Mui.IconButton>
                      </Mui.Tooltip>
                    )}
                  </>
                }
                title={
                  <Mui.Typography variant="body">
                    {t("tables.equipments.title")}
                  </Mui.Typography>
                }
              />

                <AgGridOperationTable
                gridRef={gridEquipmentsRef}
                columnDefs={equipmentsColumns}
                cacheBlockSize={10}
                rowModelType="serverSide"
                serverSideDatasource={equipmentsDatasource}
                serverSideInfiniteScroll={true}
                totalElements={totalEquipments}
                emptyState={{
                  title:selectedEquipmentKit
                    ? t("tables.equipments.emptyState.noEquipmentsFound.title")
                    : t("tables.equipments.emptyState.noEquipmentKitSelected.title"),
                  content:selectedEquipmentKit
                    ? t("tables.equipments.emptyState.noEquipmentsFound.content")
                    : t("tables.equipments.emptyState.noEquipmentKitSelected.content")
                }}
              />

            </Mui.Card>
          </Mui.Grid>
        </Mui.Grid>

        <Dialogs.EquipmentKitDialog
          tenant={tenant}
          isOpen={equipmentKitDialog}
          onClose={onCloseEquipmentKitDialog}
          equipmentKitId={equipmentKitId}
          onUpdateDatasource={() => {
            updateEquipmentKitsDatasource();
            updateEquipmentsDatasource();
          }}
        />

        <Dialogs.AddEquipment
          tenant={tenant}
          isOpen={addEquipmentVisible}
          onClose={onCloseAddEquipments}
          equipmentKitId={selectedEquipmentKit?.id}
          onUpdateDatasource={updateEquipmentsDatasource}
        />

        <Dialogs.DeleteConfirmation
          tenant={tenant}
          isOpen={deleteConfirmationVisible}
          onClose={() => setDeleteConfirmationVisible(false)}
          deleteType={deleteType}
          equipmentKit={selectedEquipmentKit}
          equipment={selectedEquipment}
          onUpdateDatasource={onUpdateDeleteConfirmation}
        />
      </Mui.Box>
    </>
  );
};
